import {
  ref,
  reactive,
  createApp,
  defineComponent,
  h,
  withDirectives,
  vShow,
  Transition,
  toRefs
} from 'vue';
import loadingPurplePng from '@/assetsCommon/common/loading-purple.png';
import loadingBluePng from '@/assetsOverseas/images/loading-blue.png';
import { removeClass } from './tools/style';

export function createLoadingComponent(options) {
  let afterLeaveTimer;

  const afterLeaveFlag = ref(false);

  const data = reactive({
    ...options,
    originalPosition: '',
    visible: false
  });

  const VixLoadingComponent = defineComponent({
    name: 'VixLoading',
    setup() {
      return () => {
        const spinner = data.svg
          ? h('svg', {
              class: 'circular',
              viewBox: data.svgViewBox ? data.svgViewBox : '0 0 60 60',
              innerHTML: data.svg
            })
          : h('img', {
              class: 'circular',
              src: IS_DOMESTIC ? loadingPurplePng : loadingBluePng,
              alt: 'loading'
            });

        const spinnerText = data.text
          ? h('p', { class: 'sbt-loading-text' }, [data.text])
          : undefined;

        return h(
          Transition,
          {
            name: 'sbt-loading-fade',
            onAfterLeave: handleAfterLeave
          },
          {
            default: () => [
              withDirectives(
                h(
                  'div',
                  {
                    style: {
                      backgroundColor: data.background || ''
                    },
                    class: [
                      'sbt-loading-mask',
                      data.customClass,
                      data.fullscreen ? 'is-fullscreen' : ''
                    ]
                  },
                  [
                    h(
                      'div',
                      {
                        class: 'sbt-loading-spinner'
                      },
                      [spinner, spinnerText]
                    )
                  ]
                ),
                [[vShow, data.visible]]
              )
            ]
          }
        );
      };
    }
  });

  const loadingInstance = createApp(VixLoadingComponent);
  const vm = loadingInstance.mount(document.createElement('div'));

  function destroySelf() {
    const target = data.parent;
    removeClass(target, 'sbt-loading-parent--relative');
    removeClass(target, 'sbt-loading-parent--hidden');
    removeVixLoadingChild();
    loadingInstance.unmount();
  }

  function removeVixLoadingChild() {
    vm.$el?.parentNode?.removeChild(vm.$el);
  }

  function close() {
    if (options.beforeClose && !options.beforeClose()) return;

    afterLeaveFlag.value = true;
    clearTimeout(afterLeaveTimer);

    afterLeaveTimer = setTimeout(handleAfterLeave, 400);
    data.visible = false;

    options.closed?.();
  }

  function handleAfterLeave() {
    if (!afterLeaveFlag.value) return;
    afterLeaveFlag.value = false;
    destroySelf();
  }

  return {
    ...toRefs(data),
    close,
    vm,
    get $el() {
      return vm.$el;
    }
  };
}
